import RespondentsConsumerAllLoyaltyProgramPanel from './respondentsConsumerAllLoyaltyProgramPanel.container';

export default RespondentsConsumerAllLoyaltyProgramPanel;